import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceHelperService } from '../../service-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient,
    private svcHelper: ServiceHelperService ) { }




  login(body ){

    //const body = { username: 'khouloud'  , password : 'TEST' };

    console.log (body,'testbody')
    const url = `${this.svcHelper.getUrl('User/signin')}`;
    return this.http.post(url, body ,{observe: 'response'});


    // this._oidcSecurityService.setCustomRequestParameters({ "audience": this._oidcConfigService.clientConfiguration.audience });
    // return this._oidcSecurityService.authorize();
  }



  
  logout(email ){

    const body = { email: email };

    console.log (email,'testbody')
    const url = `${this.svcHelper.getUrl('User/signout')}`;
    return this.http.post(url, body, {observe: 'response'}  );


  
  }

    
 VerifyUser(activationCode:String) {
  const url = `${this.svcHelper.getUrl(`User/VerifyUser/${activationCode}`)}`;
  return this.http.post(url,{observe: 'response'}  );


  }

  verifyUser(activationCode){




    const url = `${this.svcHelper.getUrl(`User/VerifyUser/${activationCode}`)}`;
    return this.http.post(url,{observe: 'response'}  );


  
  }

  signup(body ){
console.log('eeeeeeeeeeeeeeeeee',body)
    const url = `${this.svcHelper.getUrl('User/signup')}`;
    return this.http.post(url, body ,{observe: 'response'});
  }

  reconnect(email ){
    const body = { email: email };

    console.log ('body reconnect ', body)
    const url = `${this.svcHelper.getUrl('User/reconnect')}`;
    return this.http.post(url, body ,{observe: 'response'});
  }
  //26/12/2022 cyrine
  EmailsList(Email){
    const body = {email :Email };
    const url = `${this.svcHelper.getUrl('User/FindEmail')}`;
    return this.http.post(url,body,{observe: 'response'});
  }

  update(password,email){
    const body = {password:password , email:email};
    const url = `${this.svcHelper.getUrl('User/UpdatePWD')}`;
    return this.http.post(url,body,{observe: 'response'});
  }

  changePWD(email, oldpassword ,password){
    const body = {email :email ,oldpassword:oldpassword, password:password};
    const url = `${this.svcHelper.getUrl('User/ChangePWD')}`;
    return this.http.post(url,body,{observe: 'response'});
  }

  updateinformations(email,fullname,tel,adresse,ville,birthdate){
    const body = {email :email,fullname:fullname,tel:tel,adresse:adresse,ville:ville,birthdate:birthdate};
    const url = `${this.svcHelper.getUrl('User/Updateinfo')}`;
    return this.http.post(url,body,{observe: 'response'});
  }



  recentconx(Email){
    const body = {email :Email };
    const url = `${this.svcHelper.getUrl('User/recentcnx')}`;
    return this.http.post(url,body,{observe: 'response'});
  }

saveReclamation(email,objet,desc){
    const body = {email :email,objet:objet,desc:desc};
    const url = `${this.svcHelper.getUrl('User/reclamation')}`;
    return this.http.post(url,body,{observe: 'response'});
  }


 resetpwdEmail(email){
    const body = {email :email};
    const url = `${this.svcHelper.getUrl('User/resetPDWEmail')}`;
    return this.http.post(url,body,{observe: 'response'});
  }



  deactivateAccount(email, password) {
    const body = {email :email,password:password};
    const url = `${this.svcHelper.getUrl('User/desactivation')}`;
    return this.http.post(url,body,{observe: 'response'});
  }
 
 
 


  addInvitation(email,emailC){
    const body = {email:email,emailClient:emailC};
    const url = `${this.svcHelper.getUrl('Admin/addInvitation')}`;
    return this.http.post(url,body,{observe: 'response'});
  }


}
